import { mapGetters } from 'vuex'
import { GETTERS } from '@/store/constants'

export default {
  computed: {
    ...mapGetters({
      buildings: GETTERS.GET_BUILDINGS
    })
  },
  methods: {
    getBuilding (building) {
      return this.buildings.find(x => x.id === building)
    },
    setLocation (points = []) {
      points.forEach(x => {
        x.properties.location = this.getBuilding(x.properties.building)
      })
    }
  }
}
